import type {Invitation} from '@yandex-data-ui/cloud-schemas/build/models/organization-manager';

import {sendParams} from '~ui/services/metrika';

export const toEmailList = (invitations: Invitation[]) =>
    invitations.map((invitation) => {
        if ('invitee' in invitation) {
            return invitation.invitee.email;
        }
        return invitation.yandexPassportUserAccount.login;
    });

export const metrikaEvents = {
    submitInvites() {
        sendParams('Добавить пользователя', 'Добавить');
    },
    successInvite() {
        sendParams('Добавить пользователя', 'Добавить', 'Успешно');
    },
    errorInvite() {
        sendParams('Добавить пользователя', 'Добавить', 'Ошибка');
    },
    cancel() {
        sendParams('Добавить пользователя', 'Отменить');
    },
};
